import React from 'react';
import PropTypes from 'prop-types';
import {
  withStyles,
  createMuiTheme,
  MuiThemeProvider
} from '@material-ui/core/styles';
import Drawer from '@material-ui/core/Drawer';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography';
import VendorAlertTable from "./VendorAlertTable";
import CustomerAlertTable from "./CustomerAlertTable";
import EmployeeAlertTable from "./Entities/vendor/EmployeeAlertTable";
import SideMenuList from "./SharedComponents/SideMenuList_try";
import TransactionAlerts from "./Transactions/TransactionAlerts";
import RoutineDetailTable from "./Routines/RoutineDetailTable";
import Dashboard from "./Dashboard/DashboardNew";
import AlertSummary from "./Dashboard/AlertSummary";
import ProcurementOverview from "./Dashboard/ProcurementOverview";
import EntityCustomerTable from "./Entities/Employees/EntityCustomerTable";
import { CapitalizeFirstLetter } from '../util/StringUtil';
import Tooltip from '@material-ui/core/Tooltip';
import ManagementDashboard from "./Dashboard/ManagementDashboard_demo";
import MyDashboard from "./Dashboard/MyDashboard_demo";
//Menu import
import Avatar from '@material-ui/core/Avatar';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import Collapse from '@material-ui/core/Collapse';
import FaceIcon from '@material-ui/icons/Face';
import ExpandLess from '@material-ui/icons/ExpandLess';
import ExpandMore from '@material-ui/icons/ExpandMore';
import StarBorder from '@material-ui/icons/StarBorder';
import ViewModule from '@material-ui/icons/ViewModule';
import SwapHoriz from '@material-ui/icons/SwapHoriz';
import FormatListBulleted from "@material-ui/icons/FormatListBulleted";
import steve from '../pic/steve.PNG';
//import for variat drawer
import MenuIcon from '@material-ui/icons/Menu';
import classNames from 'classnames';
import IconButton from '@material-ui/core/IconButton';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ChevronLeftIcon from '@material-ui/icons/ChevronLeft';
import logo from '../pic/KPMG_logo.svg.png'
import axios from 'axios';
import config from '../config/config';
import { theme } from '../components/CSS/MenuStyles';
import RoutineIndex from './Routines/RoutineIndex'
import {routineIndexDataQualityData,
  routineIndexSegDutyData,
  routineIndexVendorScoreData,
  routineIndexUnusualTransacData,
  routineIndexTimingData,
  routineIndexUnusualRecordData
} from './Routines/RoutineIndexData'
import VendorClusterAnalysis from './Routines/VendorClusterAnalysis'


const drawerWidth = 240;

function jsUcfirst(string) {
  return string.charAt(0).toUpperCase() + string.slice(1);
}

const styles = theme => ({
  root: {
    flexGrow: 1,
    height: '100vh',
    zIndex: 1,
    overflow: 'hidden',
    position: 'relative',
    display: 'flex',
  },
  appBar: {
    zIndex: theme.zIndex.drawer + 1,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
  },
  appBarShift: {
    marginLeft: drawerWidth,
    width: `calc(100% - ${drawerWidth}px)`,
    transition: theme.transitions.create(['width', 'margin'], {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  menuButton: {
    marginLeft: 0,
    marginRight: 36,
    padding: 7
  },
  hide: {
    display: 'none',
  },
  drawerPaper: {
    position: 'relative',
    whiteSpace: 'nowrap',
    width: drawerWidth,
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.enteringScreen,
    }),
  },
  drawerPaperClose: {
    overflowX: 'hidden',
    transition: theme.transitions.create('width', {
      easing: theme.transitions.easing.sharp,
      duration: theme.transitions.duration.leavingScreen,
    }),
    width: theme.spacing.unit * 10,
    [theme.breakpoints.up('sm')]: {
      width: theme.spacing.unit * 10,
    },
  },
  content: {
    overflow: 'auto',
    flexGrow: 1,
    backgroundColor: theme.palette.background.default,
    // padding: theme.spacing.unit * 3,
    marginTop: '58px',
    padding: '8px',
    // paddingTop: theme.spacing.unit * 3,
    minWidth: 0, // So the Typography noWrap works
  },
  toolbar: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0 8px',
    ...theme.mixins.toolbar,
  },
  rootMenu: {
    width: '100%',
    backgroundColor: theme.palette.background.paper,
  },
  nested0: {
    paddingLeft: theme.spacing.unit * 4,
  },
  nested: {
    paddingLeft: theme.spacing.unit * 2,
  },
  avatar: {
    width: 30,
    height: 30
  },
  thicc: {
    fontWeight: 600,
  },
  thiccer: {
    fontWeight: 600,
  }
});

class ClippedDrawer extends React.Component {
  state = {
    perspective: "Dashboard",
    displayName: "Dashboard",
    open: false,
    menuOpen: false,
    procurementOpen: false,
    ERMOpen: false,
    routinesOpen: false,
    transactionsOpen: false
  };
  handleDrawerOpen = () => {
    if (this.state.open == false) {
      this.setState({ open: true });
    }
  };

  handleDrawerClose = (event) => {
    //console.log(event.pageX)
    if (this.state.open == true && event.pageX > 250) {
      this.setState({ open: false });
    }
  };

  handleClick = () => {
    this.setState(state => ({ menuOpen: !state.menuOpen }));
  };
  handleRoute = (route, name) => {
    this.setState({ perspective: route, displayName: name ? name : route });
    this.handleDrawerOpen;
    // console.log(this.state.displayName);
    // console.log(this.state.perspective);
    // console.log("clicked menu");
    // switch ( this.props.location.pathname.substr(1)) {
    //   case 'dashboard':
    //     this.setState({ perspective: 'Dashboard'});
    //     break
    //   case 'transactions':
    //     this.setState({ perspective: 'Transactions'});
    //     break
    //   case 'vendors':
    //     this.setState({ perspective: 'Vendors', menuOpen:true });
    //     break
    //   case 'employees':
    //     this.setState({ perspective: 'Employees' });
    //     break
    //   case 'purchaseorders':
    //     this.setState({ perspective: 'Purchase Orders', transactionsOpen:true });
    //     break
    //   case 'invoices':
    //     this.setState({ perspective: 'Invoices', transactionsOpen:true });
    //     break
    //   case 'customers':
    //     this.setState({ perspective: 'Customers', menuOpen:true });
    //     break
    //   case 'conflictinterest':
    //     this.setState({ perspective: 'Conflict Interest', routinesOpen:true, ERMOpen:true});
    //     break
    //   case 'duplicateaddress':
    //     this.setState({ perspective: 'Duplicate Address', routinesOpen:true, ERMOpen:true});
    //     break
    //   case 'duplicatepo':
    //     this.setState({ perspective: 'Duplicate PO', routinesOpen:true, procurementOpen:true});
    //     break
    //   case 'benford':
    //     this.setState({ perspective: 'Benford', routinesOpen:true, ERMOpen:true});
    //     break
    //   default:
    //     this.setState({ perspective: 'Dashboard'});
    // }
    this.props.history.push('/' + route.toLowerCase());
  }
  handleIconClick = () => {
    this.setState({ open: true });
  }
  componentWillMount() {
    axios.defaults.headers.common["Authorization"] = 'token ' + this.props.token;
    // set perspective based on route
    // let route = this.props.location.pathname.substr(1)
    // if (this.state.perspective != route)
    // {
    //   this.setState({
    //     perspective: route
    //   })
    //   this.props.history.push('/'+route.toLowerCase().replace(/\s/g,''));
    // }
    // console.log(this.props.location.pathname.substr(1))
    // console.log( this.state.displayName+"will mount")
    // console.log( this.props)
  }

  handleLogOut = () => {

    axios.post(config.auth + '/logout/', {},
      {}).then(res => { console.log(res) })
      .catch(error => {
        console.log(error)
      })
    axios.defaults.headers.common["Authorization"] = '';
    this.props.logout();
    this.props.history.push("/login");
  }



  render() {
    const { classes } = this.props;
    let toRender = null;

    const vendorAlertTable = (<VendorAlertTable />);
    const customerAlertTable = (<CustomerAlertTable />);
    const employeeAlertTable = (<EmployeeAlertTable />);
    const routineDetailTable = (<RoutineDetailTable />);
    const transactionAlerts = (<TransactionAlerts type={"purchase orders"} />);
    const dashboard = (<Dashboard />);
    const entityCustomerTable = (<EntityCustomerTable />);
    const summary = (<AlertSummary />);
    const overview = (<ProcurementOverview />);
    const routineIndexObj = {
      dataquality: <RoutineIndex data={routineIndexDataQualityData} handleRoute={this.handleRoute} />,
      segduty: (<RoutineIndex data={routineIndexSegDutyData} handleRoute={this.handleRoute} />),
      vendorscore: (<RoutineIndex data={routineIndexVendorScoreData} handleRoute={this.handleRoute} />),
      unusualtransac: (<RoutineIndex data={routineIndexUnusualTransacData} handleRoute={this.handleRoute} />),
      timing: (<RoutineIndex data={routineIndexTimingData} handleRoute={this.handleRoute} />),
      unusualrecord: (<RoutineIndex data={routineIndexUnusualRecordData}handleRoute={this.handleRoute} />)
    };
    const vendorClusterAnalysis = (<VendorClusterAnalysis/>)



    const management = (<ManagementDashboard />);
    const myDashboard = (<MyDashboard />);
    let title = this.props.location.pathname.substr(1)
    let display = title
    switch (title) {

      case 'management dashboard':
        toRender = management;
        display = "Management Dashboard"
        break
      case 'my dashboard':
        toRender = myDashboard;
        display = "My Dashboard"
        break

      case 'dashboard':
        // toRender = dashboard;
        // toRender = overview;
        toRender = management;
        display = "Management Dashboard"
        break
      case 'transaction':
        toRender = transactionAlerts;
        break
      case 'vendor':
        toRender = employeeAlertTable;
        break
      case 'employee':
        toRender = employeeAlertTable;
        break
      case 'purchase order':
      case 'purchase orders':
        toRender = transactionAlerts;
        display = 'purchase order'
        break
      case 'invoice':
      case 'invoices':
      case 'goods receipts':
      case 'payments':
        toRender = <TransactionAlerts type={title} />;
        break
      case 'customer':
        toRender = entityCustomerTable;
        break
      case 'conflict of interest':
        // console.log("now at conflict interest");
        toRender = <RoutineDetailTable username={this.props.username} type={"conflict of interest"} />;
        display = 'conflict of interest';
        break
      case 'duplicate address':
      case 'open invoice':
        toRender = <RoutineDetailTable username={this.props.username} type={'open invoice'} />;
        // display = 'duplicate address';
        break
      case 'vendor same address':
        toRender = <RoutineDetailTable username={this.props.username} type={'vendor same address'} />;
        // display = 'duplicate address';
        break
      case 'vendor same gst':
        toRender = <RoutineDetailTable username={this.props.username} type={'vendor same gst'} />;
        display = 'vendor same GST';
        break
      case 'open po':
        toRender = <RoutineDetailTable username={this.props.username} type={"open po"} />;
        display = 'open PO';
        break
      case 'duplicate po':
        toRender = <RoutineDetailTable username={this.props.username} type={"duplicate po"} />;
        display = 'duplicate PO';
        break
      case 'gr amount larger than po amount':
        toRender = <RoutineDetailTable username={this.props.username} type={"gr amount larger than po amount"} />;
        display = 'Unusual Transaction Data';
        break
      case 'invoice amount larger than gr amount':
        toRender = <RoutineDetailTable username={this.props.username} type={"invoice amount larger than gr amount"} />;
        display = 'Unusual Transaction Data';
        break
      case 'invoice amount larger than po amount':
        toRender = <RoutineDetailTable username={this.props.username} type={"Invoice amount larger than po amount"} />;
        display = 'Unusual Transaction Data';
        break
      case 'payment amount larger than invoice amount':
        toRender = <RoutineDetailTable username={this.props.username} type={"payment amount larger than invoice amount"} />;
        display = 'Unusual Transaction Data';
        break

      case 'benford':
        toRender = customerAlertTable;
        break
      case 'enterprise rm':
        toRender = dashboard;
        display = 'enterprise RM';
        break
      case 'overview':
        toRender = overview;
        display = "Procurement Overview"
        break
      case 'summary':
        toRender = summary;
        display = "Alert Status Summary"
        break
      case 'data quality':
        toRender = routineIndexObj.dataquality;
        display = "Data Quality"
        break
      case 'segregation of duties':
        toRender = routineIndexObj.segduty;
        display = "Segregation Of Duties"
        break
      case 'vendor anomaly score':
        toRender = routineIndexObj.vendorscore;
        display = "Vendor Anomaly Score"
        break
      case 'unusual transactions':
        toRender = routineIndexObj.unusualtransac;
        display = "Unusual Transaction"
        break
      case 'timing irregularities':
        toRender = routineIndexObj.timing;
        display = "Timing Irregularities"
        break
      case 'unusual vendor records':
        toRender = routineIndexObj.unusualrecord;
        display = "Unusual Vendor Records"
        break
      case 'vendor cluster analysis':
        toRender = vendorClusterAnalysis;
        display = "vendor cluster analysis"
        break
      default:
        // toRender = dashboard;
        // display = 'dashboard';
        toRender = management;
        display = "Management Dashboard"

    }



    return (
      <MuiThemeProvider theme={theme}>
        <div className={classes.root} onClick={this.handleDrawerClose}>
          <AppBar position="absolute" className={classNames(classes.appBar, this.state.open && classes.appBarShift)}>
            <Toolbar style={{ backgroundColor: "rgb(0,145,218)", minHeight: "58px" }}>
              <IconButton
                color="inherit"
                aria-label="Open drawer"
                onClick={this.handleDrawerOpen}
                className={classNames(classes.menuButton, this.state.open && classes.hide)}
              >
                <MenuIcon />
              </IconButton>
              <Typography variant="h6" color="inherit" noWrap>
                {CapitalizeFirstLetter(display)}
              </Typography>
              <div style={{ flex: '1', textAlign: 'right' }}>
              {/* <img src={steve} style={{marginTop:"1%", width:"10%"}}/> */}
                <Tooltip title="Log Out" aria-label="Log Out">
                  <IconButton style={{ color: 'rgb(255,255,255)' }}
                    onClick={() => {
                      // console.log('log out'); 
                      this.handleLogOut();
                    }}>
                    <i class="fas fa-sign-out-alt fa-1x" ></i>
                  </IconButton>
                </Tooltip>
              </div>
            </Toolbar>
          </AppBar>
          <Drawer
            variant="permanent"
            classes={{
              paper: classNames(classes.drawerPaper, !this.state.open && classes.drawerPaperClose),
            }}
            open={this.state.open}
          >
            <div
              className={classes.toolbar}
            >
              <img src={logo} style={{ width: "100px", height: "auto", marginLeft: "auto", marginRight: "auto", marginTop: "10px" }} />
              {/*<IconButton onClick={this.handleDrawerClose}>
                          {!this.state.open ? <ChevronRightIcon /> : <ChevronLeftIcon />}
                        </IconButton>*/}
            </div>
            <SideMenuList handleRoute={this.handleRoute} handleIconClick={this.handleIconClick} shouldOpen={this.state.open}/>
          </Drawer>
          <main className={classes.content}>
            {toRender}
          </main>
        </div>
      </MuiThemeProvider>
    );
  }
}

ClippedDrawer.propTypes = {
  classes: PropTypes.object.isRequired,
};

export default withStyles(styles)(ClippedDrawer);



// WEBPACK FOOTER //
// ./src/components/ClippedDrawer.js